export default __webpack_public_path__ + "static/media/florayfauna5.396c67d4.jpg";